import { render, staticRenderFns } from "./search-page.vue?vue&type=template&id=6b3a9a90&scoped=true&"
import script from "./search-page.vue?vue&type=script&lang=js&"
export * from "./search-page.vue?vue&type=script&lang=js&"
import style0 from "./search-page.vue?vue&type=style&index=0&id=6b3a9a90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../kuaishou-frontend-collect/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3a9a90",
  null
  
)

export default component.exports